// extracted by mini-css-extract-plugin
export var button = "image-text-button-module--button--w--PQ";
export var content = "image-text-button-module--content--IDf8C";
export var image = "image-text-button-module--image--lzzix";
export var innerWrapper = "image-text-button-module--inner-wrapper--zJoyR";
export var text = "image-text-button-module--text--Rbye3";